import Api from '@/vuex/api'
import { app } from '@/main'
import {
  ACCEPT_QUOTE,
  COMPLETE_WORK_ORDER,
  UNCOMPLETE_WORK_ORDER,
  SCHEDULE_QUOTE_ACCESS,
  VIEW_QUOTE_ACCESS,
  GRANT_ACCESS_QUOTE,
  REQUEST_QUOTE_SIGNATURE,
  UNACCEPT_QUOTE,
  TERMINATE_QUOTE,
  ASSIGN_QUOTE,
  ADD_REPORT_PRICING,
  CURRENT_QUOTES_SEARCH,
  DELETE_QUOTE,
  DUPLICATE_QUOTE,
  START_INSPECTION,
  END_INSPECTION,
  EDIT_INSPECTION_TIMES,
  VIEW_INSPECTION_TIMES,
  EDIT_REPORT_PRICING,
  LOAD_QUOTES,
  LOAD_QUOTE_NOTES,
  ADD_QUOTE_NOTE,
  LOAD_REPORT_INFO,
  OPEN_MODAL,
  SEND_QUOTE,
  UPLOAD_REPORT_ICON,
  GET_QUOTE_TRELLO_ATTACHMENTS,
  GET_QUOTE_ATTACHMENTS
} from '@/vuex/types'

const api = new Api()

const state = {
  quotes: {
    columns: [],
    count: 0,
    permalink: false,
    rows: [],
    links: [],
    noResults: '',
    offset: 0,
    limit: 20,
    searchForm: {
      fields: []
    }
  },
  reportInfo: [],
  currentQuotesSearch: {},
  quoteNotes: {
    rows: [],
    count: 0
  }
}

const getters = {
  quotes ({ quotes }) {
    return quotes
  },
  quotesSearchForm ({ quotes }) {
    return quotes.searchForm
  },
  reportInfo ({ reportInfo }) {
    return reportInfo
  },
  /**
   * Description: quoteNotes function is used to retrieve all the notes corresponding to a quote
   * @param {*} { quoteNotes }
   */
  quoteNotes ({ quoteNotes }) {
    return quoteNotes
  }
}

const mutations = {
  [LOAD_QUOTES] (context, quotes) {
    quotes.searchForm.fields.push({
      type: 'text',
      label: 'Results Per Page',
      name: 'limit',
      fullWidth: quotes.searchForm.fullWidth,
      value: quotes.limit.toString()
    })
    context.quotes = quotes
  },
  [LOAD_QUOTE_NOTES] (context, quoteNotes) {
    context.quoteNotes = quoteNotes
  },
  [CURRENT_QUOTES_SEARCH] (context, options) {
    context.currentQuotesSearch = options
  },
  [LOAD_REPORT_INFO] (context, options) {
    context.reportInfo = options
  }
}

const actions = {
  async [ASSIGN_QUOTE] (context, QuoteUuid) {
    let assignQuoteModal = {
      permalink: 'assignQuote',
      options: {
        title: 'Assign Quote',
        actionLabel: 'Assign'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, assignQuoteModal)
  },
  [GET_QUOTE_TRELLO_ATTACHMENTS] (context, quoteUuid) {
    let trelloAttachmentModal = {
      permalink: 'getTrelloAttachments',
      options: {
        title: 'Trello Attachments'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, trelloAttachmentModal)
  },
  [GET_QUOTE_ATTACHMENTS] (context, quoteUuid) {
    let attachmentModal = {
      permalink: 'getQuoteAttachments',
      options: {
        title: 'Quote Attachments',
        actionLabel: 'Save'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, attachmentModal)
  },
  [COMPLETE_WORK_ORDER] (context, quoteUuid) {
    let completeWorkOrderModal = {
      permalink: 'completeWorkOrder',
      options: {
        title: 'Complete Work Order',
        actionLabel: 'Complete'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, completeWorkOrderModal)
  },
  [UNCOMPLETE_WORK_ORDER] (context, quoteUuid) {
    let uncompleteWorkOrderModal = {
      permalink: 'uncompleteWorkOrder',
      options: {
        title: 'Uncomplete Work Order',
        actionLabel: 'Uncomplete'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, uncompleteWorkOrderModal)
  },
  [ACCEPT_QUOTE] (context, quoteUuid) {
    let acceptQuoteModal = {
      permalink: 'acceptQuote',
      options: {
        title: 'Accept Quote',
        actionLabel: 'Accept'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, acceptQuoteModal)
  },
  [REQUEST_QUOTE_SIGNATURE] (context, quoteUuid) {
    let requestQuoteSignatureModal = {
      permalink: 'requestQuoteSignature',
      options: {
        title: 'Request Signature',
        actionLabel: 'Request'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, requestQuoteSignatureModal)
  },
  [UNACCEPT_QUOTE] (context, quoteUuid) {
    let unacceptQuoteModal = {
      permalink: 'unacceptQuote',
      options: {
        title: 'Unaccept Quote',
        actionLabel: 'Unaccept'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, unacceptQuoteModal)
  },
  async [TERMINATE_QUOTE] (context, quoteUuid) {
    let terminateQuoteModal = {
      permalink: 'feedBack',
      options: {
        title: 'Termination Feed Back',
        actionLabel: 'Terminate'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, terminateQuoteModal)
  },
  async [DUPLICATE_QUOTE] (context, QuoteUuid) {
    let newQuoteUuid = await api.duplicateQuote(QuoteUuid)
    app.$router.push('/quotes/edit/' + newQuoteUuid)
  },
  [SEND_QUOTE] (context, QuoteUuid) {
    let sendModal = {
      permalink: 'sendQuote',
      options: {
        title: 'Send Quote',
        actionLabel: 'Send'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  // async [END_INSPECTION] (context, quoteUuid) {
  //   let endInspectionModal = {
  //     permalink: 'endInspection',
  //     options: {
  //       title: 'End Inspection',
  //       actionLabel: 'End'
  //     },
  //     params: {
  //       quoteUuid
  //     }
  //   }
  //   context.dispatch(OPEN_MODAL, endInspectionModal)
  // },
  async [EDIT_INSPECTION_TIMES] (context, quoteUuid) {
    let editInspectionTimesModal = {
      permalink: 'editInspectionTimes',
      options: {
        title: 'Edit Inspection Times',
        actionLabel: 'Save'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, editInspectionTimesModal)
  },
  async [VIEW_INSPECTION_TIMES] (context, quoteUuid) {
    let viewInspectionTimesModal = {
      permalink: 'viewInspectionTimes',
      options: {
        title: 'View Inspection Times',
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, viewInspectionTimesModal)
  },
  async [VIEW_QUOTE_ACCESS] (context, quoteUuid) {
    let viewQuoteAccessModal = {
      permalink: 'viewQuoteAccess',
      options: {
        title: 'View Site Access',
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, viewQuoteAccessModal)
  },
  async [SCHEDULE_QUOTE_ACCESS] (context, quoteUuid) {
    let scheduleQuoteAccessModal = {
      permalink: 'scheduleQuoteAccess',
      options: {
        title: 'Schedule Access',
        actionLabel: 'Schedule Site Access'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, scheduleQuoteAccessModal)
  },
  [DELETE_QUOTE] (context, QuoteUuid) {
    let modal = {
      permalink: 'deleteQuote',
      options: {
        title: 'Delete Quote',
        actionLabel: 'Delete'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, modal)
  },
  async [LOAD_QUOTES] (context, options) {
    if (!options) {
      options = context.state.currentQuotesSearch
    }
    let data = await api.getQuotes(options)
    context.commit(LOAD_QUOTES, data)
    context.commit(CURRENT_QUOTES_SEARCH, options)
  },
  async [ADD_QUOTE_NOTE] (context, quoteUuid) {
    let addQuoteNoteModal = {
      permalink: 'addQuoteNote',
      options: {
        title: 'Add Note',
        actionLabel: 'Save'
      },
      params: {
        uuid: quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, addQuoteNoteModal)
  },
  async [LOAD_QUOTE_NOTES] (context, quoteUuid) {
    let data = await api.getQuoteNotes(quoteUuid)
    context.commit(LOAD_QUOTE_NOTES, data)
  },
  async [LOAD_REPORT_INFO] (context) {
    let data = await api.getReportInfo()
    context.commit(LOAD_REPORT_INFO, data)
  },
  async [UPLOAD_REPORT_ICON] (context, reportTypeUuid) {
    let uploadModal = {
      permalink: 'uploadReportIcon',
      options: {
        title: 'Upload Icon',
        actionLabel: 'Save'
      },
      params: {
        reportTypeUuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadModal)
  },
  async [ADD_REPORT_PRICING] (context, reportTypeUuid) {
    let pricingModal = {
      permalink: 'addReportPricing',
      options: {
        title: 'Add Pricing',
        actionLabel: 'Save'
      },
      params: {
        reportTypeUuid
      }
    }
    context.dispatch(OPEN_MODAL, pricingModal)
  },
  async [EDIT_REPORT_PRICING] (context, reportTypeUuid) {
    let pricingModal = {
      permalink: 'editReportPricing',
      options: {
        title: 'Edit Pricing',
        actionLabel: 'Save'
      },
      params: {
        reportTypeUuid
      }
    }
    context.dispatch(OPEN_MODAL, pricingModal)
  }
}

export default {
  actions,
  getters,
  mutations,
  state
}




// WEBPACK FOOTER //
// ./src/vuex/modules/quotes.js